import { type NavItemType } from '@/defs/nav'
import { cn } from '@/utils/commonUtil'

import styles from '../HeaderNav.module.scss'
import { HeaderNavButton } from '../HeaderNavButton/HeaderNavButton'

type Props = {
  item: NavItemType
  onClickLink?: () => void
}

export const HeaderNavMenuInner = ({ item, onClickLink }: Props) => {
  return (
    item.submenu && (
      <ul className={cn(styles.menuInner, { size: item.size, styles })}>
        {item.submenu.map((itemSub) =>
          itemSub.variant === 'divider' ? (
            <li className={styles.divider} key={itemSub.id} role='separator' />
          ) : (
            <li className={styles.itemInner} key={itemSub.id}>
              <HeaderNavButton className={styles.buttonInner} item={itemSub} onClickLink={onClickLink} />
              <HeaderNavMenuInner item={itemSub} onClickLink={onClickLink} />
            </li>
          ),
        )}
      </ul>
    )
  )
}
